var Theme = {};

const BREAKPOINT_LARGEDESKTOP   = 1800;
const BREAKPOINT_MEDIUMDESKTOP  = 1500;
const BREAKPOINT_DESKTOP        = 1360;
const BREAKPOINT_LAPTOP         = 1200;
const BREAKPOINT_TABLETHOR      = 1024;
const BREAKPOINT_TABLET         = 768;
const BREAKPOINT_PHABLET        = 576;
const BREAKPOINT_MOBILE         = 325;


(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.Theme = {};

  /**
   * Constructeur
   */
  Theme.Common = function () {
    // Éléments
    this.elements = {
      htmlBody: $('html, body'),
      body: $('body'),
      page: $('#page'),
    };

    this.elements.externalLinks = this.elements.page.find('a[href^="http"]');
    this.elements.openInNewWindowLinks = this.elements.page.find('a[href$=".pdf"]');

    // Variables
    this.menuScrollOffset = 110;
    this.langcode = drupalSettings.path.currentLanguage || 'fr';

    return this;
  };

  /**
   * Méthodes
   */
  Theme.Common.prototype = {
    load: function (className, options) {
      if (Theme[className] !== undefined) {
        return new Theme[className](this, options);
      } else {
        console.error('Class "Theme.' + className + '" not found.');
      }
    },
    autoload: function (options) {
      var self = this;

      if (options !== undefined) {
        $.each(options, function (className, condition) {
          if (self.elements.body.is(condition)) {
            return self.load(className).init();
          }
        });

      } else {
        console.error('Options is undefined.');
      }
    },

    /**
     * Init common
     */
    init: function () {
      this.cookieTarteAuCitronHandler();
      this.externalLinksHandler();
      this.openInNewWindowHandler();
      this.anchorLinksHandler();
    },

    /**
     * Gestionnaire de CookieNotice
     */
    cookieTarteAuCitronHandler: function () {
      var gtmGoogle =  drupalSettings.GTMcookie;
      tarteaucitron.init({
          "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
          "highPrivacy": true, /* désactiver le consentement implicite (en naviguant) ? */
          "AcceptAllCta" : true,
          "orientation": "middle", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
          "adblocker": false, /* Afficher un message si un adblocker est détecté */
          "showAlertSmall": false, /* afficher le petit bandeau en bas à droite ? */
          "cookieslist": true, /* Afficher la liste des cookies installés ? */
          "removeCredit": true, /* supprimer le lien vers la source ? */
          "useExternalCss": true,
          "showIcon": false
      });
      tarteaucitron.user.googletagmanagerId = gtmGoogle;
      (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
      (tarteaucitron.job = tarteaucitron.job || []).push('vimeo');
      (tarteaucitron.job = tarteaucitron.job || []).push('dailymotion');
      (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');

      // lien pour ouvir le gestionnaire de cookies
      $('.link-cookies').on('click touch', function (e) {
        e.preventDefault();
        tarteaucitron.userInterface.openPanel();
      });
    },

    /**
     * Gestionnaire des liens externes
     */
    externalLinksHandler: function () {
      if (this.elements.externalLinks.length) {
        this.elements.externalLinks.each(function (i, link) {
          link = $(link);

          if (link.attr('href').indexOf(window.location.host) === -1) {
            link.attr('target', '_blank');
          }
        });
      }
    },

    /**
     * Gestionnaire pour l'ouverture de lien dans un nouvel onglet
     */
    openInNewWindowHandler: function () {
      if (this.elements.openInNewWindowLinks.length) {
        this.elements.openInNewWindowLinks.on('click', function (event) {
          event.preventDefault();
          window.open($(event.currentTarget).attr('href'));
        });
      }
    },

    /**
     * Gestionnaire des ancres
     */
    anchorLinksHandler: function () {
      var self = this;

      self.elements.page.on('click', 'a[href*="#"]:not([href="#"])', function (event) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            event.preventDefault();

            self.scrollTop(target.offset().top);
          }
        }
      });
    },

    /**
     * Scroll top
     *
     * @param offset
     * @param speed
     */
    scrollTop: function (offset, speed) {
      speed = speed || 500;

      this.elements.htmlBody.animate({
        scrollTop: (offset - this.menuScrollOffset)
      }, speed);

      return this;
    },

  };

  /**
   * Load Themes
   * @type {{attach: attach, detach: detach}}
   */
  Drupal.behaviors.drupTheme = {
    attach: function (context) {
      if (context.body !== undefined) {
        Drupal.Theme = new Theme.Common();
        Drupal.Theme.init();
        Drupal.Theme.load('all').init();

        // Drupal.Theme.autoload({
        //     front: '.is-front'
        // });
      }
      // page meat : init. slider
      else if ($(context).is('.node--type--meat, .node--view-mode--full')) {
        Drupal.Theme = new Theme.Common();
        //Drupal.Theme.init();
        Drupal.Theme.load('all').initSliderMeats();
      }
    }
  };

}(jQuery, Drupal, drupalSettings));

function initFiltersCatalogMeat() {
  (function($) {

    // svg cochon
    $('.filters-pig').append($('.pig'));

    // déplacement tags en mode mobile
    if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
      $('.filters-meat-tags').insertAfter($('#filters-meat'));
    }

    // état des ouvertures des listes de checkbox
    for (let numListChk=1; numListChk<=3; numListChk++) {
      //$('body').on('click touch', '.filter-chk-wrapper-level' + numListChk + ' .filter-chk-label', function (e) {
      $('.filter-chk-wrapper-level' + numListChk + ' .filter-chk-label').on("click touch", function (e) {
        e.preventDefault();

        let filterChkLevel = $('body').data('filter-chk-level' + numListChk);
        if (filterChkLevel != undefined && filterChkLevel == 'open') {
          $('.filter-chk-wrapper-level' + numListChk).removeClass('open');
          $('body').data('filter-chk-level' + numListChk, '');
        }
        else {
          $('.filter-chk-wrapper-level' + numListChk).addClass('open');
          $('body').data('filter-chk-level' + numListChk, 'open');
        }
      });
      // fermetures select
      /* (desactivé car pb avec IE)
      $('body').on('mouseover', function(e) {
        if (!e.target.closest('.filter-chk-wrapper-level' + numListChk)) {
            setTimeout(function () {
              $('.filter-chk-wrapper-level' + numListChk).removeClass('open');
              $('body').data('filter-chk-level' + numListChk, '');
            }, 200);
        }
      });*/
      $('body').on('click touch', function(e) {
        if (!e.target.closest('.filter-chk-wrapper-level' + numListChk)) {
          //console.log(numListChk);
          $('.filter-chk-wrapper-level' + numListChk).removeClass('open');
          $('body').data('filter-chk-level' + numListChk, '');
        }
      });

      /*$('.filter-chk-wrapper-level' + numListChk).on("mouseover", function () {
        $('body').data('filter-chk-level' + numListChk, 'open');
      });*/
      /*$('.filter-chk-wrapper-level' + numListChk).on("mouseout", function () {
        $('.filter-chk-wrapper-level' + numListChk).removeClass('open');
        $('body').data('filter-chk-level' + numListChk, '');
      });*/

      // rendre permanente ouvertures select
      if ($('body').data('filter-chk-level' + numListChk) == 'open') {
        $('.filter-chk-wrapper-level' + numListChk).removeClass('disabled').addClass('open');

      } else {
        $('.filter-chk-wrapper-level' + numListChk).removeClass('open');
      }
    }
    // rendre permanente ouverture popin filtres
    if ($('body').data('filter-meat-mobile') != undefined && $('body').data('filter-meat-mobile') == 'open') {
      $('#filters-meat').addClass('open');
    }
    else {
      $('#filters-meat').removeClass('open');
    }

    // checkbox
    let objOptions = $('select[name="pieces[]"] option');
    let idChkLevel1 = null;
    let idChkLevel2 = null;

    objOptions.each(function(i, obj) {
      let valOption = $(obj).val();
      let idChk = '';
      let textOption = $(obj).text();
      let selectedOption = $(obj).prop('selected');
      let objGroupChk = null;
      let showChk = false;
      let level = 0;

      // niveau 3
      if (textOption.indexOf('--') == 0) {
        idChk = idChkLevel2 + "-" + valOption;
        objGroupChk = $('.chk-types-pieces');
        textOption = textOption.substr(2, textOption.length);
        //showChk = $('#' + idChkLevel2).prop('checked');
        showChk = selectedOption;
        level = 3;

        // s'il s'agit d'un enfant sélectionné :
        // afficher le parent sélectionné (mais ne pas sélectionner sa valeur)
        if (selectedOption) {
          $('#' + idChkLevel1).prop('checked', true);
          addTagCatalogMeat(idChkLevel1, $('#' + idChkLevel1 + ' + label').text(),1);

          $('.filter-chk-wrapper-level2').removeClass('disabled');
          $('#' + idChkLevel2).prop('checked', true);
          $('#' + idChkLevel2).closest('li').addClass('show');
          addTagCatalogMeat(idChkLevel2, $('#' + idChkLevel2 + ' + label').text(),2);
        }
        else {
          // si pas sélectionné mais niveau 2 sélectionné :
          // on affiche la liste de niveau 3
          if ($('#' + idChkLevel2).prop('checked')) {
            showChk = true;
          }
        }
      }
      // niveau 2
      else if (textOption.indexOf('-') == 0) {
        idChk = idChkLevel1 + "-" + valOption;
        idChkLevel2 = idChk;
        objGroupChk = $('.chk-under-pieces');
        textOption = textOption.substr(1, textOption.length);
        //showChk = $('#' + idChkLevel1).prop('checked');
        showChk = selectedOption;
        level = 2;

        // s'il s'agit d'un enfant sélectionné :
        if (selectedOption) {
          // afficher le parent sélectionné (mais ne pas sélectionner sa valeur)
          $('#' + idChkLevel1).prop('checked', true);

          // ajout du tag correspondant
          addTagCatalogMeat(idChkLevel1, $('#' + idChkLevel1 + ' + label').text(),1);
        }
        else {
          // si pas sélectionné mais niveau 1 sélectionné :
          // on affiche la liste de niveau 2
          if ($('#' + idChkLevel1).prop('checked')) {
            showChk = true;
          }
        }
      }
      // niveau 1
      else {
        idChk = 'chk-' + valOption;
        idChkLevel1 = idChk;
        objGroupChk = $('.chk-pieces');
        showChk = true;
        level = 1;
      }

      // construction des checkbox
      objGroupChk.append(
        '<li ' + (showChk ? 'class="show"' : '') + '>' +
        '<input type="checkbox" id="' + idChk + '" value="' + valOption + '" class="form-checkbox"' +
          (selectedOption ? 'checked' : '') + '>' +
        '<label for="' + idChk + '">' + textOption + '</label>' +
        '</li>'
      );
      if (showChk) {
        $('.filter-chk-wrapper-level' + level).removeClass('disabled');

        // rendre visible tous ses frèreslet tabIdChk = $(this).attr('id').split('-');
        let tabIdChk = idChk.split('-');
        if (tabIdChk.length > 2) {
          tabIdChk.pop();
          let idParent = tabIdChk.join('-');
          $('#' + idChk).closest('.filter-chk').find('input[id^="' + idParent + '-"]').closest('li').addClass('show');
        }
      }
      $('#' + idChk).on("click", function(event) {
        $('select[name="pieces[]"] option[value="' + $(this).val() + '"]').prop('selected', $(this).prop('checked'));

        // deselection : on deselectionne les enfants
        if (!$(this).prop('checked')) {
          $('input[id^="' + $(this).attr('id') + '-"]').each(function(j, objChild) {
            // facultatif : $(objChild).prop('checked', false);
            $('select[name="pieces[]"] option[value="' + $(objChild).val() + '"]').prop('selected', false);
          });
        }

        // maj de la valeur du parent :
        let tabIdChk = $(this).attr('id').split('-');
        if (tabIdChk.length > 2) {
          // pour chaque niveau (2 et 3)
          for (let cpt=0; cpt<tabIdChk.length; cpt++) {
            tabIdChk.pop();
            let idParent = tabIdChk.join('-');
            let valueParent = tabIdChk[tabIdChk.length - 1];
            let countBrothers = $(this).closest('.filter-chk').find('input[id^="' + idParent + '-"]').length;
            let countBrothersSelected = $(this).closest('.filter-chk').find('input[id^="' + idParent + '-"]:checked').length;
            let allSelected = (countBrothersSelected == countBrothers);
            let allDeselected = (countBrothersSelected == 0);

            // si tous les frères sont sélectionnés OU que tous les frères sont désélectionnés :
            // sélection de la valeur du parent (sinon : déselection)
            $('select[name="pieces[]"] option[value="' + valueParent + '"]').prop('selected', (allSelected || allDeselected));
          }
        }
        $('.filters .form-submit').click();
      });

      // construction du tag
      if (selectedOption) {
        addTagCatalogMeat(idChk, textOption, level);
      }

      // réinit du critère piece si changement du critère sale
      $('input[name="sale"]').on('change', function() {
        $('select[name="pieces[]"]').val('');
      });

    });

    // init boutons mobiles
    $('body').on('click touch', ".btn-filters-meat", function (e) {
      e.preventDefault();
      $('#filters-meat').addClass('open');
      $('body').data('filter-meat-mobile', 'open');
    });
    $('body').on('click touch', ".btn-apply-filters-meat", function (e) {
      e.preventDefault();
      $('#filters-meat').removeClass('open');
      $('body').data('filter-meat-mobile', '');
    });

  })(jQuery);
}

function addTagCatalogMeat(idChk, textOption, level) {
  (function($) {
      let idTag = idChk.replace('chk-', 'tag-');
      //console.log(idTag);
      if ($('#' + idTag).length <= 0) {
        $('.filters-meat-tags').append('<li id="' + idTag + '" class="level' + level + '">' +
          textOption +
          '</li>');
        $('#' + idTag).on("click touch", function (event) {
          let idChkTag = $(this).attr('id').replace('tag-', 'chk-');
          $('#' + idChkTag).click();
        });
      }
  })(jQuery);
}
